/** Duration of the bar shrinking into the top-bar chip. */
export const CALL_BAR_FLY_DURATION_MS = 450;
